export const PoweredByAida = () => (
  <div className='self-end bg-curtin-secondary-gray-02 text-white px-5 py-2 rounded-full text-sm font-semibold *:[font-family:var(--font-proxima-nova)] text-center whitespace-nowrap leading-[21px]'>
    Powered by AIDA
  </div>
)
